export function removeAlertIdPrefix(input: string): string {
  const prefixPattern = /^\[(\d*)\]\s*-\s*/;

  return input.replace(prefixPattern, '');
}
